import { throwError, timer } from 'rxjs'
import { retryWhen, mergeMap } from 'rxjs/operators'
import {
  RETRY_DELAY_MS,
  MAX_RETRIES,
  getHostKey,
  isTransportError,
  canAttempt,
  recordSuccess,
  recordTransportFailure,
  CircuitOpenError
} from 'utils/resilience'

/*
 * rxjs/ajax adapter for the shared retry + circuit breaker core in
 * utils/resilience.js — kept here so the fetch/axios call sites don't
 * need to depend on rxjs. Breaker state (per API host) is shared with
 * fetch/axios requests, so an outage trips the same breaker regardless
 * of which transport hit it first.
 */
export {
  getHostKey,
  isTransportError,
  canAttempt,
  recordSuccess,
  recordTransportFailure,
  CircuitOpenError
}

// Retries only transport failures, with a short linear backoff; anything
// else (a real HTTP response, or retries exhausted) passes straight through.
export const transportRetry = () => retryWhen(errors => errors.pipe(
  mergeMap((error, attemptIndex) => {
    if (attemptIndex >= MAX_RETRIES || ! isTransportError(error)) {
      return throwError(error)
    }
    return timer(RETRY_DELAY_MS * (attemptIndex + 1))
  })
))
